import { reactive, readonly } from '@vue/composition-api';
import Swal from 'sweetalert2';

const state = reactive({
    alert: null,
});

export const setAlert = (alertInstance) => {
    state.alert = alertInstance;
};

export const showAlert = async (options) => {
    return state.alert(options);
};

export const showToast = async (options) => {
    return state.alert({
        toast: true,
        ...options,
        position: options.position ? options.position : 'bottom',
        reverseButtons: false,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
    });
};

export const showLoadAlert = async () => {
    state.alert({
        title: 'Aguarde',
        html: 'Isso pode levar alguns segundos.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
};

export const showConfirmAlert = async (options) => {
    return state.alert({
        icon: 'warning',
        ...options,
        reverseButtons: true,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
    });
};

export const getState = {
    ...readonly(state),
};
